


















































import { Component, Vue } from 'vue-property-decorator';
import { Image } from '@/types/entities/Image';
import { UPLOAD_IMAGE } from '@/store/images';
import {
  GET_VESSEL_IMAGES,
  REMOVE_UPLOADED_IMAGE,
  REMOVE_VESSEL_IMAGE,
  SET_VESSEL_IMAGE_DATA,
  UPDATE_UPLOADED_IMAGE_DATA
} from '@/store/vessels';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Vessel } from '@/types/entities/Vessel';
import { VesselImage } from '@/types/entities/VesselImage';
import { isMobile } from 'mobile-device-detect';
import { mixins } from 'vue-class-component';
import PhotoIcon from '@/svg/photo.svg';
import CrossIcon from '@/svg/cross.svg';
import draggable from 'vuedraggable';
import UpArrowIcon from '@/svg/arrow-up.svg';
import DownArrowIcon from '@/svg/arrow-down.svg';
import UiKitImageDropdown from '@/components/UiKit/UiKitImageDropdown.vue';
import CropImageMixin from '@/mixins/crop.mixin';

declare interface ImageRecord {
  type: 'existed' | 'uploaded';
  image: SearchResultItem<VesselImage> | Image;
}

@Component({
  components: { UiKitImageDropdown, PhotoIcon, CrossIcon, UpArrowIcon, DownArrowIcon, draggable }
})
export default class FileUploader extends mixins(CropImageMixin, Vue) {
  get vessel(): SearchResultItem<Vessel> {
    return this.$store.state.vessels.item.data;
  }

  get images(): ImageRecord[] {
    const getPosition = (record: ImageRecord): number => {
      if (record.type === 'existed') {
        return (record.image as SearchResultItem<VesselImage>).attributes.position;
      }

      return (record.image as Image).position!;
    };

    return [
      ...this.existedImages.map((image: SearchResultItem<VesselImage>): ImageRecord => {
        return { type: 'existed', image };
      }),
      ...this.uploadedImages.map((image: Image): ImageRecord => {
        return { type: 'uploaded', image };
      })
    ].sort((record1: ImageRecord, record2: ImageRecord) => getPosition(record1) - getPosition(record2));
  }

  set images(records: ImageRecord[]) {
    records.forEach(this.setImagePosition);
  }

  get existedImages(): Array<SearchResultItem<VesselImage>> {
    return this.$store.getters[GET_VESSEL_IMAGES](this.vessel);
  }

  get uploadedImages(): Image[] {
    return this.$store.state.vessels.uploadedImages;
  }

  get isMobile(): boolean {
    return isMobile;
  }

  protected upload(files: any) {
    Array.from(files).forEach((file) =>
      this.$store.dispatch(UPLOAD_IMAGE, file)
        .then((response) => this.$emit('uploaded', response.data))
    );
  }

  protected deleteExistedImage(image: SearchResultItem<VesselImage>) {
    this.$store.commit(REMOVE_VESSEL_IMAGE, image.id);
  }

  protected deleteUploadedImage(image: Image) {
    this.$store.commit(REMOVE_UPLOADED_IMAGE, image.id);
  }

  protected moveUp(index: number) {
    const previousImage = this.images[index - 1];
    const currentImage = this.images[index];

    this.setImagePosition(previousImage, index);
    this.setImagePosition(currentImage, index - 1);
  }

  protected moveDown(index: number) {
    const nextImage = this.images[index + 1];
    const currentImage = this.images[index];

    this.setImagePosition(nextImage, index);
    this.setImagePosition(currentImage, index + 1);
  }

  protected setImagePosition(record: ImageRecord, index: number) {
    if (record.type === 'existed') {
      this.$store.commit(SET_VESSEL_IMAGE_DATA, {
        id: record.image.id,
        attributes: {
          position: index + 1
        }
      });
    }

    if (record.type === 'uploaded') {
      this.$store.commit(UPDATE_UPLOADED_IMAGE_DATA, { id: record.image.id, position: index + 1 });
    }
  }

  protected dropHandler($event: any) {
    this.upload($event.dataTransfer.files);
  }
}
